var _excluded = ["className", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import CkIcon from "../private/CkIcon";
import { nanoid } from "nanoid/non-secure";
var SaveSearchLg = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _props = _extends({}, props),
    {
      className,
      title
    } = _props,
    rest = _objectWithoutPropertiesLoose(_props, _excluded);
  var titleId = props != null && props.id ? props.id + "-title" : nanoid(5);
  return /*#__PURE__*/React.createElement(CkIcon, _extends({
    className: ["CK__Icon--large", className].filter(Boolean).join(" "),
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": title ? titleId : undefined
  }, rest), title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 2.139a8.5 8.5 0 1 0 1.396 13.715l7 7a.5.5 0 0 0 .707-.708l-7-7c.381-.428.72-.895 1.008-1.396a.5.5 0 1 0-.866-.5A7.5 7.5 0 1 1 13.25 3.005a.5.5 0 1 0 .5-.866Zm-.607 10.679a1 1 0 0 1-.411-.979l.45-2.758-1.898-1.945a1 1 0 0 1 .565-1.687l2.582-.394 1.164-2.48a1 1 0 0 1 1.81 0l1.164 2.48 2.582.394a1 1 0 0 1 .565 1.687l-1.898 1.945.45 2.758a1 1 0 0 1-1.47 1.036l-2.298-1.27-2.297 1.27a1 1 0 0 1-1.06-.057Zm3.357-2.355 1.668.921L19.28 12l-.205-1.256-.326-2 1.391-1.426.859-.88-1.216-.186-1.893-.29-.839-1.785L16.5 3l-.552 1.177-.839 1.786-1.893.289L12 6.438l.859.88 1.391 1.426-.326 2L13.719 12l1.114-.616 1.667-.921Z",
    fill: "currentColor"
  }));
});
SaveSearchLg.displayName = "SaveSearchLg";
export default SaveSearchLg;